import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Home,
  BookOpen,
  Bus,
  Utensils,
  Library,
  Settings,
  Users,
  BarChart3,
  LogOut,
  UserCheck,
  CreditCard,
  Download,
  Eye,
} from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import "./Sidebar.css";

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const { user, logout, hasPermission } = useAuth();

  // Define all possible menu items with their permissions
  const allMenuItems = [
    {
      path: "/dashboard",
      icon: Home,
      label: "Dashboard",
      permission: "dashboard",
    },
    {
      path: "/library",
      icon: BookOpen,
      label: "Library Management",
      permission: "library_manage",
    },
    {
      path: "/library/requests",
      icon: UserCheck,
      label: "Book Requests",
      permission: "library_request",
    },
    {
      path: "/library/borrow",
      icon: BookOpen,
      label: "Borrow Books",
      permission: "library_borrow",
    },
    {
      path: "/transportation",
      icon: Bus,
      label: "Transportation",
      permission: "transportation_manage",
    },
    {
      path: "/cafeteria",
      icon: Utensils,
      label: "Cafeteria & Payments",
      permission: "cafeteria_manage",
    },
    {
      path: "/cafeteria/purchase",
      icon: CreditCard,
      label: "Make Purchase",
      permission: "cafeteria_purchase",
    },
    {
      path: "/cafeteria/controls",
      icon: Settings,
      label: "Cafeteria Controls",
      permission: "cafeteria_controls",
    },
    {
      path: "/e-library",
      icon: Library,
      label: "E-Library",
      permission: "e_library_access",
    },
    {
      path: "/e-library/downloads",
      icon: Download,
      label: "My Downloads",
      permission: "e_library_download",
    },
    {
      path: "/child-monitoring",
      icon: Eye,
      label: "Child Monitoring",
      permission: "library_view_child",
    },
    {
      path: "/admin",
      icon: Settings,
      label: "Admin Panel",
      permission: "admin",
    },
  ];

  // Filter menu items based on user permissions
  const menuItems = allMenuItems.filter((item) =>
    hasPermission(item.permission)
  );

  const handleLogout = () => {
    logout();
    onClose();
  };

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      <div className={`sidebar ${isOpen ? "sidebar-open" : ""}`}>
        <div className="sidebar-header">
          <div className="logo">
            <div className="logo-text">
              <h2>GISS LMS</h2>
              <p>Library Management</p>
            </div>
          </div>
        </div>

        <div className="user-info">
          <div className="user-avatar">{user?.avatar}</div>
          <div className="user-details">
            <h4>{user?.name}</h4>
            <p className="user-role">
              {user?.role?.charAt(0).toUpperCase() + user?.role?.slice(1)}
            </p>
            {user?.grade && <p className="user-grade">{user.grade}</p>}
          </div>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-item ${isActive ? "active" : ""}`}
                onClick={onClose}
              >
                <Icon size={20} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <LogOut size={20} />
            <span>Logout</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
